<template>
  <div class="menusList" >
    <el-divider content-position="left">菜单管理列表</el-divider>
    <el-row style="margin-bottom: .4rem">
      <el-col>
        <el-button type="primary" size="small" @click="addMenu">新增</el-button>
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </el-col>
    </el-row>
    <!-- 表格 开始 -->
    <el-table ref="multipleTable" :data="menusList" style="width: 100%" row-key="id" border lazy :load="load"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
      <el-table-column prop="menu_name" label="菜单名称" width="180">
      </el-table-column>
      <el-table-column prop="client_route" label="路由地址" width="180">
      </el-table-column>
      <el-table-column prop="sort" label="排序">
      </el-table-column>
      <el-table-column prop="status" label="是否显示">
        <template slot-scope="scope" v-if="!scope.row.hasChildren">
          <el-switch
            style="display: block"
            v-model="hideShow[scope.row.id]"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="显示"
            inactive-text="隐藏"
            @click.native="editListRadio(scope.row)"
            > 
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button @click.native.prevent="editMenuInfo(scope.row)" type="primary" size="mini" icon="el-icon-edit"
              circle>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 表格 结束 -->
    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper" :total="total" :page-sizes="[10, 15, 30, 50]"
        :page-size="pageSize" background>
      </el-pagination>
    </div>
    <el-drawer title="新增" :visible.sync="addMenuDrawer" :direction="direction" :before-close="handleClose" size="40%">
      <div style="padding: 1em 1.4em; margin-top: -17px">
        <el-form :model="addMenuForm" ref="addMenuForm" label-width="100px">
          <el-form-item label="菜单名称" prop="menu_name">
            <el-input v-model="addMenuForm.menu_name" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="父级菜单" prop="menu_name">
            <el-select v-model="addMenuForm.cate_name" placeholder="请选择父级菜单" size="mini">
              <el-option v-for="(cate_name, index) in parentMenusList" :key="index" :label="cate_name.cate_name"
                :value="cate_name.cate_name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="路由地址" prop="client_route">
            <el-input v-model="addMenuForm.client_route" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model="addMenuForm.sort" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="显示请求权限">
            否
            <el-switch v-model="addMenuForm.auth_show" active-color="#ff4949" inactive-color="#13ce66">
            </el-switch>
            是
          </el-form-item>
          <el-form-item label="显示菜单">
            否
            <el-switch v-model="addMenuForm.status" active-color="#ff4949" inactive-color="#13ce66">
            </el-switch>
            是
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitAddForm()">保存</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer title="修改" :visible.sync="editMenuDataDrawer" :direction="direction" :before-close="handleClose"
      size="40%">
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form :model="editMenuForm" ref="editMenuForm" label-width="100px">
          <el-form-item label="菜单名称" prop="menu_name">
            <el-input v-if="editMenuForm.isFirstLevel" v-model="editMenuForm.menu_name" size="mini"></el-input>
            <el-input v-else v-model="editMenuForm.menu_name" :disabled="true" size="mini"></el-input>
          </el-form-item>
          <el-form-item v-if="editMenuForm.isFirstLevel" label="路由地址" prop="client_route">
            <el-input v-model="editMenuForm.client_route" size="mini"></el-input>
          </el-form-item>
          <el-form-item v-if="editMenuForm.isFirstLevel" label="排序" prop="sort">
            <el-input v-model="editMenuForm.sort" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="显示请求权限">
            <el-switch v-model="editMenuForm.auth_show" active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否">
            </el-switch>
          </el-form-item>
          <el-form-item v-if="editMenuForm.isFirstLevel" label="显示菜单">
            <el-switch v-model="editMenuForm.status" active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否">
            </el-switch>
          </el-form-item>
          <div style="text-align: right">
            <el-button type="primary" size="mini" @click="submitForm('editMenuForm')">保存</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'MenusManage',
  data () {
    return {

      currentPage: 1,
      pageSize: 10,
      total: null,
      search: {
        menuName: ''
      },
      hideShow: [],
      searcher: null,
      searchLoading: false,
      searchMenuNames: [],
      menusList: [],
      menusTempData: [],
      childrenList: [],
      editMenuDataDrawer: false,
      addMenuDrawer: false,
      direction: 'rtl',
      addMenuForm: {
        menu_name: '',
        client_route: '',
        sort: '',
        auth_show: false,
        status: false,
        cate_name: ''
      },
      editMenuForm: {
        menu_name: '',
        client_route: '',
        sort: '',
        auth_show: false,
        status: false,
        id: '',
        isFirstLevel: false
      },
      parentMenusList: []
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    loadTable () {
      this.$axios
        .get('api/menus_manage/index', {
          params: {
            page: this.currentPage,
            perpage: this.pageSize,
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.menusList = data.data.menus
            this.menusList.forEach((item, index) => {
              this.$set(item, 'id', index + '-' + item.cate_name)
              this.$set(item, 'hasChildren', true)
              this.$set(item, 'menu_name', item.cate_name)
              this.$set(item, 'sort', item.m_sort)
              this.$set(item, 'status', item.status)
            })
            this.total = data.data.totalCount
          }
        })
        .catch()
    },
    loadRadio () {
      this.childrenList.map(item => {
        if (item.status === 1) {
          this.hideShow[item.id] = true
        } else {
          this.hideShow[item.id] = false
        }
      })
    },
    editListRadio (row) {
      console.log(row)
      this.$axios
        .post('api/admin/update/show_or_hide', {
          id: row.id,
          display: this.hideShow[row.id] === false ? 0 : 1
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    load (tree, treeNode, resolve) {
      this.$axios.get('api/menus_manage/get_child_menu', {
        params: {
          cate_name: tree.cate_name
        }
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.childrenList = data.data.childrenMmenus
            this.loadRadio()
          }
        }).catch()
      setTimeout(() => {
        resolve(this.childrenList)
      }, 1000)
    },
    addMenu () {
      this.$axios
        .get('api/menus_manage/get_parent_menu')
        .then(({ data }) => {
          if (data.code === 0) {
            this.parentMenusList = data.data.menus
          }
        })
        .catch()
      this.addMenuDrawer = true
    },
    editMenuInfo (row) {
      if (!row.hasChildren) {
        this.editMenuForm.isFirstLevel = true
        this.editMenuForm.client_route = row.client_route
        if (row.status === 1) {
          this.editMenuForm.status = true
        } else {
          this.editMenuForm.status = false
        }
        if (row.auth_show === 1) {
          this.editMenuForm.auth_show = true
        } else {
          this.editMenuForm.auth_show = false
        }
        this.editMenuForm.id = row.id
      }
      this.editMenuForm.menu_name = row.menu_name
      this.editMenuForm.sort = row.sort
      this.editMenuDataDrawer = true
    },
    submitAddForm () {
      if (this.addMenuForm.menu_name === '') {
        this.$message.error('菜单名称不能为空')
        return
      }
      if (this.addMenuForm.cate_name === '') {
        this.$message.error('父级菜单不能为空')
        return
      }
      if (this.addMenuForm.client_route === '') {
        this.$message.error('路由地址不能为空')
        return
      }
      if (this.addMenuForm.sort === '') {
        this.$message.error('排序值不能为空')
        return
      }
      this.$axios
        .post('api/menus_manage/add_menu_info', {
          param: this.addMenuForm
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.addMenuDrawer = false
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    refreshRow() {
      this.$set(this.$refs.multipleTable.store.states, 'lazyTreeNodeMap', {})
      this.$set(this.$refs.multipleTable.store.states, 'treeData', {})
    },
    submitForm () {
      this.$axios
        .post('api/menus_manage/update_menu_info', {
          param: this.editMenuForm
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.refreshRow()
            this.editMenuDataDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    searchRemoteMenuName (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchMenuNames = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/menus_manage/get_menuname', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchMenuNames = data.data
          }
        })
        .catch()
    },
    handleSearchMenuName (query) {
      this.currentPage = 1
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.loadTable()
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.editMenuForm.isFirstLevel = false
          done()
        })
        .catch(_ => { })
    }
  },
  mounted () {
    this.loadTable()
  }
}
</script>

<style  scoped>
.menusList {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/menus_manage/MenuManage.vue